"use client";
import styles from "./HowToUseSideDrawer.module.scss";
import { cleanHtml } from "../../../utils/string/cleanHtml";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { useState } from "react";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";
type Props = {
  howtoUseContent: string | null | undefined;
};

export const HowToUseSideDrawerUI = ({ howtoUseContent }: Props) => {
  const [open, setOpen] = useState(false);
  if (!howtoUseContent) return null;

  return (
    <>
      <ListItem
        label="How to use"
        onClick={withSideDrawerAnalytics("How To Use", () => setOpen(true))}
        trailingIcon={<ChevronRight size="medium" />}
        data-testid="drawer:howtouse"
      />
      <Drawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading={"How to use"}
        primaryButtonText="Close"
      >
        <div
          data-testid="howToUse:Description"
          className={styles.productDescriptionBody}
          dangerouslySetInnerHTML={{ __html: cleanHtml(howtoUseContent) || "" }}
        />
      </Drawer>
    </>
  );
};
